export default (category,action,label,value) => {
    if(window && window.ga){
        try {
            ga('send', 'event', category, action, label, value);
        }catch(e){
            console.log(e);
        }
    }
}
